import { request } from '@lib/request';

export function createFunderStatement(payload) {
    return request({
        method: 'post',
        url: '/api/report/funder-statement',
        data: payload
    })
}

export function getFunderStatementUrl(key: string) {
    return request({
        method: 'get',
        url: `/api/report/pre-signed-url?key=${key}`,
    })
}